import * as React from 'react';

/**
 * An extension to useState<boolean> that creates 2 callbacks
 * to set the state to true / false
 */
export const useBooleanState = (
  init: boolean = false,
): [
  boolean,
  React.Dispatch<React.SetStateAction<boolean>>,
  () => void,
  () => void,
] => {
  const [state, setState] = React.useState(init);
  const enableCallback = React.useCallback(() => {
    setState(true);
  }, [setState]);
  const disableCallback = React.useCallback(() => {
    setState(false);
  }, [setState]);
  return [state, setState, enableCallback, disableCallback];
};
